import React from "react";
import Avatar from '../base/Avatar';
import Call from '../../modules/voice/calls/models/Call';
import Icon from '../base/Icon';
import { callRecordingUrl, clearGlobalPlayer, getOwner, useGlobal, useHub } from '../../core/Global';
import { CallSources, CallTypes } from "../../core/Enums";
import { API_ROUTES } from "../../core/Constants";

type Props = {
    selectedCall: Call,
    onPause?: (e: React.SyntheticEvent<HTMLAudioElement, Event>) => void,
    onPlay?: (e: React.SyntheticEvent<HTMLAudioElement, Event>) => void
}

function FloatAudioPlayer(props: Props) {
    const hub = useHub()
    const owner = getOwner();

    const [globalState, setGlobalState] = useGlobal();

    // The two outgoing Twilio legs are told apart by isCallback, as in CallsList: a callback is
    // the customer ringing the job's proxy number; otherwise a technician dialled the passcode to
    // reach the customer, often from a number the system does not know them by.
    const call = props.selectedCall;
    const isTwilioOutgoing = call.callSource == CallSources.Twilio && call.callType == CallTypes.Outgoing;
    const isCustomerCallback = isTwilioOutgoing && !!call.isCallback;
    const isTechToCustomer = isTwilioOutgoing && !call.isCallback;

    const PartyItem = (p: { avatarUrl?: string, name?: string, number?: string }) => (
        <>
            <div className="me-2">
                <Avatar avatarUrl={p.avatarUrl} width={20} />
            </div>
            <div>
                <div className="fs-7 text-white limited-text mw-150px">
                    {p.name}
                </div>
                <div className="fs-9 text-white ">
                    {p.number}
                </div>
            </div>
        </>
    )

    return (
        <>
            <div className="float-audio-player">
                <div className="d-flex align-items-center px-6 py-4">

                    {
                        isTechToCustomer ?
                            <PartyItem avatarUrl={call.tech?.avatarUrl}
                                name={call.tech?.fullName ?? "Technician"}
                                number={call.tech?.phoneNumber ?? call.source} />
                            : isCustomerCallback || (call.callSource == CallSources.Twilio && call.callType == CallTypes.Incoming) ?
                                <PartyItem name={call.job?.fullName} number={call.job?.phone?.phoneFriendly} />
                                :
                                <>
                                    <div>
                                        <Avatar avatarUrl={call.sourceAgent?.country ? call.sourceAgent.country.flagSquare : call.sourceAgent?.avatarUrl}
                                            width={20} />
                                    </div>
                                    <div className="ms-2">
                                        {
                                            call.sourceAgent?.id ?
                                                <div className="fs-7 text-white">
                                                    {call.sourceAgent?.name}
                                                </div>
                                                :
                                                <div className="fs-7 text-white">
                                                    {call.sourceAgent?.number}
                                                </div>
                                        }
                                    </div>
                                </>
                    }

                    <div className="text-center ms-5 me-5">
                        <Icon type="solid" icon="phone-volume" className="text-success" size={14} />
                    </div>

                    {
                        call.callSource == CallSources.Twilio && call.callType == CallTypes.Incoming ?
                            <PartyItem avatarUrl={call.tech?.avatarUrl} name={call.tech?.fullName} number={call.tech?.phoneNumber} />
                            : isCustomerCallback ?
                                <PartyItem name="Job Line" number={call.destination} />
                                : isTechToCustomer ?
                                    <PartyItem name={call.job?.fullName} number={call.job?.phone?.phoneFriendly} />
                                :
                                <>
                                    <div>
                                        <Avatar avatarUrl={props.selectedCall.destinationAgent?.country ? props.selectedCall.destinationAgent.country.flagSquare : props.selectedCall.destinationAgent?.avatarUrl}
                                            width={20} />
                                    </div>
                                    <div className="ms-2">
                                        {
                                            props.selectedCall.destinationAgent?.id ?
                                                <div className="fs-7 text-white">
                                                    {props.selectedCall.destinationAgent?.name}
                                                </div>
                                                :
                                                <div className="fs-7 text-white">
                                                    {props.selectedCall.destinationAgent?.number}
                                                </div>
                                        }
                                    </div>
                                </>
                    }


                    <div className="ms-5" style={{
                        flexGrow: 1
                    }}>
                        <audio autoPlay
                            id="global-float-audio-player"
                            style={{
                                width: "100%",
                                minWidth: 400,
                                height: 40
                            }}
                            onPause={e => {
                                setGlobalState({
                                    floatAudioStatus: {
                                        playing: false
                                    }
                                });
                                if (props.onPause) props.onPause(e);
                            }}
                            onPlay={e => {
                                setGlobalState({
                                    floatAudioStatus: {
                                        playing: true
                                    }
                                });
                                if (props.onPlay) props.onPlay(e);


                                hub.Post(API_ROUTES.Calls + "listenstart", {
                                    id: props.selectedCall.id
                                }, res => {

                                })

                            }}
                            onEnded={e => {
                                //console.log(e, "end");
                            }}
                            src={callRecordingUrl(owner?.id, props.selectedCall.id)} controls></audio>
                    </div>
                    <div className="ms-5">
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            $(".data-row").removeClass("selected");
                            clearGlobalPlayer();
                        }}>
                            <Icon type="solid" icon="times" color="#444" size={16} />
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FloatAudioPlayer;